export type VttItem = {
  part: string;
  start: string;
  end: string;
  endTs: number;
  startTs: number;
  targetPart?: string;
};

export type VttData = {
  type: string;
  options: Record<string, string>;
  items: VttItem[];
};

/**
 * Parses a timestamp string (hh:mm:ss.mmmm) to milleseconds.
 */
export const parseTimeString = (timeStr: string): number => {
  const [h, m, t] = timeStr.split(':');
  const [s, ms] = t.split('.');
  const [hours, minutes, seconds, milleseconds] = [h, m, s, ms].map((v) =>
    parseInt(v, 10),
  );
  return (
    milleseconds + seconds * 1000 + minutes * 60 * 1000 + hours * 60 * 60 * 1000
  );
};

/**
 * Convert vtt to json.
 */
export function vttToJson(vtt: string): VttData {
  const [header, ...parts] = vtt.split(/\n\n/g);

  const items = parts
    .map((item) => {
      return item.split(/\n/g);
    })
    .filter((arr) => parseInt(arr[0], 10) > -1)
    .map((item) => {
      const timestampIndex = item.findIndex((row) =>
        row.match(/\d\d:\d\d:\d\d.\d\d\d/g),
      );

      const newItem = item.slice(timestampIndex);
      const [timestamp, ...parts] = newItem;
      const part = parts.join(' ');

      const [start, end] = timestamp.split(' --> ');

      return {
        part,
        start,
        startTs: parseTimeString(start),
        end,
        endTs: parseTimeString(end),
      };
    })
    .filter((item) => item.part);

  const [fileType, ...headerDataRows] = header.split('\n');
  const headerData = headerDataRows.reduce((obj, d) => {
    const [key, value] = d.split(':');
    return { ...obj, [key.trim()]: value.trim() };
  }, {});

  const data = {
    type: fileType,
    options: headerData,
    items,
  };

  return data;
}
